module.exports = __webpack_public_path__ + "Panton-SemiBold.0dc231c6574b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Panton-SemiBold.woff
// module id = ./src/styles/fonts/Panton-SemiBold.woff
// module chunks = 21